import React from 'react';

const SpacerBlockEditor = ({ block, onUpdate }) => {
  const handleChange = (field, value) => {
    onUpdate(block.id, {
      config: {
        ...block.config,
        [field]: value,
      },
    });
  };

  return (
    <div>
      <div className="editor-section">
        <h4 className="editor-section-title">Spacer Settings</h4>

        <div className="editor-field">
          <label>Height (px)</label>
          <input
            type="range"
            min="10"
            max="200"
            step="5"
            value={block.config.height || 40}
            onChange={(e) => handleChange('height', parseInt(e.target.value))}
            style={{ width: '100%' }}
          />
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '0.5rem' }}>
            <span style={{ color: '#999', fontSize: '0.875rem' }}>10px</span>
            <span style={{ color: '#fff', fontWeight: 'bold' }}>{block.config.height || 40}px</span>
            <span style={{ color: '#999', fontSize: '0.875rem' }}>200px</span>
          </div>
        </div>

        <div className="editor-field">
          <label>Quick Presets</label>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '0.5rem', marginTop: '0.5rem' }}>
            <button
              type="button"
              onClick={() => handleChange('height', 20)}
              style={{
                padding: '0.5rem',
                fontSize: '0.75rem',
                backgroundColor: block.config.height === 20 ? '#ff0080' : '#333',
                color: '#fff',
                border: 'none',
                borderRadius: '0.25rem',
                cursor: 'pointer',
              }}
            >
              Small
              <div style={{ fontSize: '0.65rem', opacity: 0.7 }}>20px</div>
            </button>
            <button
              type="button"
              onClick={() => handleChange('height', 40)}
              style={{
                padding: '0.5rem',
                fontSize: '0.75rem',
                backgroundColor: block.config.height === 40 ? '#ff0080' : '#333',
                color: '#fff',
                border: 'none',
                borderRadius: '0.25rem',
                cursor: 'pointer',
              }}
            >
              Medium
              <div style={{ fontSize: '0.65rem', opacity: 0.7 }}>40px</div>
            </button>
            <button
              type="button"
              onClick={() => handleChange('height', 80)}
              style={{
                padding: '0.5rem',
                fontSize: '0.75rem',
                backgroundColor: block.config.height === 80 ? '#ff0080' : '#333',
                color: '#fff',
                border: 'none',
                borderRadius: '0.25rem',
                cursor: 'pointer',
              }}
            >
              Large
              <div style={{ fontSize: '0.65rem', opacity: 0.7 }}>80px</div>
            </button>
            <button
              type="button"
              onClick={() => handleChange('height', 120)}
              style={{
                padding: '0.5rem',
                fontSize: '0.75rem',
                backgroundColor: block.config.height === 120 ? '#ff0080' : '#333',
                color: '#fff',
                border: 'none',
                borderRadius: '0.25rem',
                cursor: 'pointer',
              }}
            >
              XLarge
              <div style={{ fontSize: '0.65rem', opacity: 0.7 }}>120px</div>
            </button>
          </div>
        </div>

        <div className="editor-field">
          <label>Custom Height</label>
          <input
            type="number"
            min="10"
            max="500"
            value={block.config.height || 40}
            onChange={(e) => handleChange('height', parseInt(e.target.value))}
            placeholder="40"
          />
        </div>

        <div style={{
          marginTop: '1.5rem',
          padding: '1rem',
          backgroundColor: '#1a1a1a',
          borderRadius: '0.375rem',
          border: '1px solid #333'
        }}>
          <div style={{ color: '#999', fontSize: '0.875rem', marginBottom: '0.5rem' }}>Preview</div>
          <div style={{
            width: '100%',
            height: `${block.config.height || 40}px`,
            backgroundColor: '#2a2a2a',
            border: '1px dashed #ff0080',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#ff0080',
            fontSize: '0.75rem'
          }}>
            {block.config.height || 40}px
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpacerBlockEditor;
